import { render, staticRenderFns } from "./DetailInfoManage.vue?vue&type=template&id=789859d4&scoped=true"
import script from "./DetailInfoManage.vue?vue&type=script&lang=js"
export * from "./DetailInfoManage.vue?vue&type=script&lang=js"
import style0 from "./DetailInfoManage.vue?vue&type=style&index=0&id=789859d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789859d4",
  null
  
)

export default component.exports